<template>
    <div class="align-center flex-1-0-0 pr-3">
        <v-chip class="d-block mr-2 bg-grey-lighten-4 rounded-0 pa-0" size="small" variant="flat">
            <svg-icon :icon="calendar" alt="calendar" />
            <span data-id="orderHistoryItemCreatedAt" class="ml-4 text-secondary-light">{{ formatTimestamp(createdAt) }}</span>
        </v-chip>
        <v-chip v-if="isTicket" class="d-block mr-2 bg-grey-lighten-4 rounded-0 pa-0" size="small" variant="flat" color="grey-lighten-4">
            <svg-icon :icon="card" alt="card" />
            <span class="ml-4 text-body-2 secondary-text-color">{{ setToCard(t('order.setToCard')) }}</span>
        </v-chip>
        <div v-if="orderLineZones" class="d-flex flex-wrap">
            <template v-if="isAllZones">
                <order-history-card-zone :zone-name="t('travelCard.allZones')" />
            </template>
            <template v-for="zone in orderLineZones" v-else :key="zone.id">
                <order-history-card-zone :zone-name="zone.name" />
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import { IOrderHistoryCardMeta } from '../../types';
import { formatTimestamp } from '@/helpers';
import { useI18n } from 'vue-i18n';
import SvgIcon from '@/features/common/components/SvgIcon.vue';
import calendar from '@/assets/calendar.svg';
import card from '@/assets/card.svg';
import OrderHistoryCardZone from './OrderHistoryCardZone.vue';

const { t } = useI18n();

const setToCard = (translation: string) => `${translation} ${props.travelCardName} (${props.travelCardId})`;

const props = defineProps<IOrderHistoryCardMeta>();
</script>
